// frontend/app/components/lessonPlans/LessonUploadParts.js
//
// Presentational pieces shared by every surface that drives useLessonUpload:
// the hidden <input type="file"> and the dismissable inline error panel.
// Failure is shown inline, never alert(): a rejected document usually has
// several things wrong with it, and an author fixing a file needs the whole
// list in front of them while they edit it.

import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

/** The file input, kept out of sight behind whatever button opens it. */
export const HiddenLessonFileInput = ({ inputRef, onChange }) =>
  React.createElement("input", {
    ref: inputRef,
    type: "file",
    accept: "application/json,.json",
    style: { display: "none" },
    onChange,
  });

export const LessonUploadErrorPanel = ({ errors, onDismiss, colors, t }) => {
  if (!errors || errors.length === 0) return null;
  return (
    <View
      testID="lesson-upload-errors"
      style={[
        styles.panel,
        { borderColor: colors.border, backgroundColor: colors.panelBg },
      ]}
    >
      <Text style={[styles.panelTitle, { color: colors.textPrimary }]}>
        {t("This lesson could not be uploaded")}
      </Text>
      {errors.map((line, index) => (
        <Text
          key={`${index}-${line}`}
          testID="lesson-upload-error-item"
          style={[styles.panelLine, { color: colors.textSecondary }]}
        >
          {line}
        </Text>
      ))}
      <TouchableOpacity
        testID="lesson-upload-errors-dismiss"
        onPress={onDismiss}
        accessibilityRole="button"
        accessibilityLabel={t("Dismiss")}
      >
        <Text style={[styles.dismiss, { color: colors.accentPrimary }]}>
          {t("Dismiss")}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  panel: { marginTop: 8, borderWidth: 1, borderRadius: 8, padding: 12, gap: 4 },
  panelTitle: { fontSize: 13, fontWeight: "700", marginBottom: 4 },
  panelLine: { fontSize: 12, lineHeight: 18 },
  dismiss: { fontSize: 12, fontWeight: "700", marginTop: 6 },
});
